import type { LocaleMessageBundle } from '../../types'

export const manufacturingMessages: LocaleMessageBundle = {
  vi: {
    'manufacturing.recipe.title': 'Định mức sản xuất',
    'manufacturing.recipe.actions.create': 'Tạo định mức',
    'manufacturing.recipe.actions.update': 'Cập nhật định mức',
    'manufacturing.recipe.actions.addMaterial': 'Thêm nguyên vật liệu',
    'manufacturing.recipe.materials': 'Nguyên vật liệu',
    'manufacturing.production.title': 'Phiếu sản xuất',
    'manufacturing.production.actions.create': 'Thêm phiếu sản xuất',
    'manufacturing.production.actions.update': 'Cập nhật phiếu sản xuất',
    'manufacturing.production.actions.save': 'Lưu tạm',
    'manufacturing.production.actions.complete': 'Hoàn thành phiếu',
    'manufacturing.production.actions.saveAndCreateReceipts': 'Lưu & tạo phiếu nhập nháp',
    'manufacturing.production.actions.calculateMaterials': 'Tính toán nguyên vật liệu',
    'manufacturing.production.actions.print': 'In phiếu sản xuất',
    'manufacturing.production.actions.cancel': 'Hủy',
    'manufacturing.production.actions.deleteTitle': 'Xóa phiếu sản xuất nháp',
    'manufacturing.production.messages.deleteConfirm': 'Bạn có chắc muốn xóa phiếu sản xuất {code}?',
    'manufacturing.production.actions.cancelTitle': 'Hủy phiếu sản xuất',
    'manufacturing.production.actions.cancelConfirm': 'Hủy',
    'manufacturing.production.messages.cancelConfirm':
      'Bạn có chắc muốn hủy phiếu sản xuất {code}?',
    'manufacturing.production.fields.cancelReason': 'Lý do hủy',
    'manufacturing.production.errors.cancelReasonRequired':
      'Lý do hủy phải có ít nhất 3 ký tự.',
    'manufacturing.production.errors.cancelReasonTooLong':
      'Lý do hủy không được vượt quá {max} ký tự.',
    'manufacturing.production.fields.selectProducts': 'Chọn sản phẩm cần sản xuất',
    'manufacturing.production.fields.outputLocations': 'Vị trí lưu kho thành phẩm',
    'manufacturing.production.messages.selectAtLeastOneProduct':
      'Hãy chọn ít nhất một sản phẩm cần sản xuất.',
    'manufacturing.production.sections.general': 'Thông tin chung',
    'manufacturing.production.sections.products': 'Sản phẩm sản xuất',
    'manufacturing.production.sections.materials': 'Nguyên vật liệu',
    'manufacturing.production.hints.calculating': 'Đang tính toán nguyên vật liệu...',
    'manufacturing.production.hints.calculateRequired':
      'Bấm "Tính toán nguyên vật liệu" để kiểm tra trước khi hoàn tất.',
    'manufacturing.production.summary.enough': '{count} NVL đủ',
    'manufacturing.production.summary.shortage': '{count} NVL thiếu',
    'manufacturing.production.summary.estimatedCost': 'Giá vốn dự kiến',
    'manufacturing.production.filters.onlyShortage': 'Chỉ hiện NVL thiếu',
    'manufacturing.production.messages.insufficient':
      'Nguyên vật liệu chưa đủ để hoàn thành phiếu.',
    'manufacturing.production.messages.sufficient': 'Nguyên vật liệu đủ để hoàn thành phiếu.',
    'manufacturing.procurement.title': 'Chuẩn bị nhập nguyên vật liệu thiếu',
    'manufacturing.procurement.description':
      'Các nguyên vật liệu cùng nhà cung cấp sẽ được gom vào một phiếu nhập nháp.',
    'manufacturing.procurement.receiptSummary': 'Sẽ tạo {count} phiếu nhập nháp',
    'manufacturing.procurement.notPurchasable': 'Không thể nhập mua',
    'manufacturing.procurement.selectSupplier': 'Chọn nhà cung cấp',
    'manufacturing.procurement.completeRequired':
      'Vui lòng chọn nhà cung cấp và kiểm tra đủ thông tin nhập cho tất cả nguyên vật liệu thiếu.',
    'manufacturing.procurement.createdTitle': 'Đã tạo phiếu nhập nháp',
    'manufacturing.procurement.createdDescription':
      'Phiếu sản xuất vẫn ở trạng thái nháp. Bạn có thể mở từng phiếu nhập để bổ sung thông tin.',
    'manufacturing.procurement.openReceipt': 'Mở phiếu nhập',
    'manufacturing.procurement.fields.purchaseQuantity': 'SL nhập',
    'manufacturing.procurement.fields.supplier': 'Nhà cung cấp',
    'manufacturing.procurement.fields.unitCost': 'Đơn giá',
    'manufacturing.production.fields.maxProducible': 'Có thể sản xuất tối đa',
    'manufacturing.fields.outputProduct': 'Thành phẩm',
    'manufacturing.fields.material': 'Nguyên vật liệu',
    'manufacturing.fields.recipe': 'Định mức',
    'manufacturing.fields.version': 'Phiên bản',
    'manufacturing.fields.outputQuantity': 'Số lượng thành phẩm chuẩn',
    'manufacturing.fields.quantity': 'Số lượng',
    'manufacturing.fields.unit': 'Đơn vị',
    'manufacturing.fields.branch': 'Chi nhánh',
    'manufacturing.fields.productionDate': 'Ngày sản xuất',
    'manufacturing.fields.code': 'Mã phiếu',
    'manufacturing.fields.status': 'Trạng thái',
    'manufacturing.fields.effectiveFrom': 'Ngày hiệu lực',
    'manufacturing.fields.note': 'Ghi chú',
    'manufacturing.fields.actions': 'Thao tác',
    'manufacturing.fields.required': 'Cần dùng',
    'manufacturing.fields.available': 'Tồn hiện tại',
    'manufacturing.fields.shortage': 'Thiếu',
    'manufacturing.fields.estimatedCost': 'Giá vốn dự kiến',
    'manufacturing.fields.sufficient': 'Đủ kho',
    'manufacturing.labels.enough': 'Đủ',
    'manufacturing.labels.missing': 'Thiếu',
    'manufacturing.statuses.draft': 'Nháp',
    'manufacturing.statuses.active': 'Đang áp dụng',
    'manufacturing.statuses.retired': 'Ngừng áp dụng',
    'manufacturing.statuses.posted': 'Hoàn thành',
    'manufacturing.statuses.cancelled': 'Đã hủy',
    'manufacturing.filters.searchPlaceholder': 'Tìm theo mã phiếu, thành phẩm...',
    'manufacturing.errors.saveFailed': 'Không thể lưu dữ liệu sản xuất.',
    'manufacturing.production.viewDetail': 'Xem chi tiết',
  },
  en: {
    'manufacturing.filters.searchPlaceholder': 'Search by order code, output product...',
    'manufacturing.recipe.title': 'Manufacturing recipes',
    'manufacturing.recipe.actions.create': 'Create recipe',
    'manufacturing.recipe.actions.update': 'Update recipe',
    'manufacturing.recipe.actions.addMaterial': 'Add material',
    'manufacturing.recipe.materials': 'Materials',
    'manufacturing.production.title': 'Production orders',
    'manufacturing.production.actions.create': 'Create production order',
    'manufacturing.production.actions.update': 'Update production order',
    'manufacturing.production.actions.save': 'Save draft',
    'manufacturing.production.actions.complete': 'Complete order',
    'manufacturing.production.actions.saveAndCreateReceipts': 'Save & create draft receipts',
    'manufacturing.production.actions.calculateMaterials': 'Calculate materials',
    'manufacturing.production.actions.print': 'Print production order',
    'manufacturing.production.actions.cancel': 'Cancel order',
    'manufacturing.production.actions.deleteTitle': 'Delete draft production order',
    'manufacturing.production.messages.deleteConfirm': 'Delete production order {code}?',
    'manufacturing.production.actions.cancelTitle': 'Cancel production order',
    'manufacturing.production.actions.cancelConfirm': 'Cancel',
    'manufacturing.production.messages.cancelConfirm':
      'Are you sure you want to cancel production order {code}?',
    'manufacturing.production.fields.cancelReason': 'Cancel reason',
    'manufacturing.production.errors.cancelReasonRequired':
      'Cancel reason must be at least 3 characters.',
    'manufacturing.production.errors.cancelReasonTooLong':
      'Cancel reason must not exceed {max} characters.',
    'manufacturing.production.fields.selectProducts': 'Select products to manufacture',
    'manufacturing.production.fields.outputLocations': 'Finished goods storage locations',
    'manufacturing.production.messages.selectAtLeastOneProduct':
      'Select at least one product to manufacture.',
    'manufacturing.production.sections.general': 'General information',
    'manufacturing.production.sections.products': 'Products to manufacture',
    'manufacturing.production.sections.materials': 'Materials',
    'manufacturing.production.hints.calculating': 'Calculating materials...',
    'manufacturing.production.hints.calculateRequired':
      'Run "Calculate materials" to verify availability before completing.',
    'manufacturing.production.summary.enough': '{count} enough',
    'manufacturing.production.summary.shortage': '{count} short',
    'manufacturing.production.summary.estimatedCost': 'Estimated cost',
    'manufacturing.production.filters.onlyShortage': 'Shortage only',
    'manufacturing.production.messages.insufficient':
      'Materials are insufficient to complete this order.',
    'manufacturing.production.messages.sufficient':
      'Materials are sufficient to complete this order.',
    'manufacturing.procurement.title': 'Prepare shortage procurement',
    'manufacturing.procurement.description':
      'Materials from the same supplier are grouped into one draft receipt.',
    'manufacturing.procurement.receiptSummary': '{count} draft receipt(s) will be created',
    'manufacturing.procurement.notPurchasable': 'Cannot purchase',
    'manufacturing.procurement.selectSupplier': 'Select supplier',
    'manufacturing.procurement.completeRequired':
      'Select a supplier and complete purchase details for every shortage material.',
    'manufacturing.procurement.createdTitle': 'Draft purchase receipts created',
    'manufacturing.procurement.createdDescription':
      'The production order remains a draft. Open each receipt to complete its details.',
    'manufacturing.procurement.openReceipt': 'Open purchase receipt',
    'manufacturing.procurement.fields.purchaseQuantity': 'Purchase qty',
    'manufacturing.procurement.fields.supplier': 'Supplier',
    'manufacturing.procurement.fields.unitCost': 'Unit cost',
    'manufacturing.production.fields.maxProducible': 'Maximum producible',
    'manufacturing.fields.outputProduct': 'Output product',
    'manufacturing.fields.material': 'Material',
    'manufacturing.fields.recipe': 'Recipe',
    'manufacturing.fields.version': 'Version',
    'manufacturing.fields.outputQuantity': 'Standard output quantity',
    'manufacturing.fields.quantity': 'Quantity',
    'manufacturing.fields.unit': 'Unit',
    'manufacturing.fields.branch': 'Branch',
    'manufacturing.fields.productionDate': 'Production date',
    'manufacturing.fields.code': 'Order code',
    'manufacturing.fields.status': 'Status',
    'manufacturing.fields.effectiveFrom': 'Effective from',
    'manufacturing.fields.note': 'Note',
    'manufacturing.fields.actions': 'Actions',
    'manufacturing.fields.required': 'Required',
    'manufacturing.fields.available': 'Available',
    'manufacturing.fields.shortage': 'Shortage',
    'manufacturing.fields.estimatedCost': 'Estimated cost',
    'manufacturing.fields.sufficient': 'Sufficient',
    'manufacturing.labels.enough': 'Enough',
    'manufacturing.labels.missing': 'Missing',
    'manufacturing.statuses.draft': 'Draft',
    'manufacturing.statuses.active': 'Active',
    'manufacturing.statuses.retired': 'Retired',
    'manufacturing.statuses.posted': 'Completed',
    'manufacturing.statuses.cancelled': 'Cancelled',
    'manufacturing.errors.saveFailed': 'Unable to save manufacturing data.',
    'manufacturing.production.viewDetail': 'View details',
  },
}
